export const ApiVersion = '2017-04-24';
export const marketplaceApiVersion = '2017-04-15';
export const enrichReviewCommentsApiVersion = '2021-03-01';
export const catalogServicesApiVersion = '2021-06-01';
export const reviewsCatalogApiVersion = '2021-03-01';
export const newSearchApiVersion = '2023-01-01-preview';
export const rnrApiVersion = '2021-03-01';
export const marketplaceLeadsApiVersion = '2022-07-01';
export const marketplaceLeadsCustomersApiVersion = '2019-03-31';
export const oneTaxonomyApiVersion = '2022-02-02';
